function addSlider ($el, number) {
    var reallyNumber = $el.find('.swiper-slide').length;
    console.log(reallyNumber);
    
    var surplusNumber = reallyNumber % number;
    if (surplusNumber == 0) {
        return;
    }
    for (var i = 0; i < number - surplusNumber; i++) {
        $el.find('.swiper-wrapper').append($el.find('.swiper-slide').eq(0).clone().html(''));
    }
}

window.addSlider = addSlider;

function imgGallery() {
    $('.img-gallery').each(function(index, item){
        let $el = $(item);
        let childTagName = '';
        try{
        childTagName = $el.children().first().get(0).tagName;
        }catch(e){
            console.log();
        }
        console.log(childTagName);
        if(childTagName){

            $el.magnificPopup({
                delegate: childTagName,
                type: 'image',
                closeOnContentClick: false,
                closeBtnInside: false,
                mainClass: 'mfp-with-zoom mfp-img-mobile',
                image: {
                    verticalFit: true,
                    titleSrc: function(item) {
                        console.log($(item));
                        console.log($(item.el[0]).data('title'));
                        return $(item.el[0]).data('title');
                    }
                },
                gallery: {
                    enabled: true
                },
                zoom: {
                    enabled: true,
                    duration: 300, // don't foget to change the duration also in CSS
                    opener: function(element) {
                        console.log('element', element);
                        return element.find('img');
                    }
                }
                
            })
        }
    });
}

window.imgGallery = imgGallery;